import { makeNoteAPIs } from '../../modules/noteAPIFactory'
import { getCaseNoteListData } from './mockData'
import type { ICaseNote } from '~/types/note/models'

export const {
  getNotes: getCaseNotes,
  postNote: postCaseNote,
  patchNote: patchCaseNote,
  deleteNote: deleteCaseNote,
  handlers,
} = makeNoteAPIs<ICaseNote>({
  apiPathEntityNamePrefix: 'case',
  getNoteListDataFn: getCaseNoteListData,
})
